import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form, FormGroup, Button } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import FormItem from '../../../common/forms/FormItem';
import { isRequired, validateEndDate } from '../../../../utils/validators';
import DatePicker from '../../../common/forms/input/DatePicker';
import FormFooter from '../../../common/forms/FormFooter';
import AgencySelect from '../../../common/forms/select/AgencySelect';
import { tzNormalizeDate } from '../../../../utils/date';
import { DATE_FORMAT } from '../../../../config/locale';

const validateDate = (value, allValues) =>
  validateEndDate(value, allValues.fromDateString);

export const BillingSearchForm = ({ handleSubmit, exportEndpoint }) => {
  const formProps = { onSubmit: handleSubmit };

  const handleExport = (values) => {
    if (!exportEndpoint) {
      console.error('No export endpoint provided');
      return;
    }

    const fromDate = tzNormalizeDate({
      date: values.fromDateString,
      format: DATE_FORMAT,
    });

    const toDate = tzNormalizeDate({
      date: values.toDateString,
      format: DATE_FORMAT,
    });

    const queryParts = [`issueDateBetween:${fromDate}_${toDate}`];

    if (values.agencyId) {
      queryParts.push(`agencyId:${values.agencyId.value}`);
    }
    const params = new URLSearchParams();
    queryParts.forEach((q) => params.append('query', q));

    const url = `${exportEndpoint}?${params.toString()}&download=true`;

    window.open(url, '_blank');
  };

  return (
    <Form {...formProps}>
      <FormGroup row>
        <FormItem label="Desde" required>
          <Field
            name="fromDateString"
            component={DatePicker}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Hasta" required>
          <Field
            name="toDateString"
            component={DatePicker}
            validate={[isRequired, validateDate]}
          />
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Agencia">
          <Field name="agencyId" component={AgencySelect} isClearable />
        </FormItem>
      </FormGroup>

      <Row>
        <Col className="flex row-reverse">
          <FormFooter
            saveButtonText="Buscar"
            saveButtonIcon="fa fa-search"
            saveButtonColor="secondary"
          >
            <Button
              type="button"
              className="btn btn-success me-2"
              onClick={handleSubmit(handleExport)}
            >
              <i className="fa fa-file-excel-o me-1" /> Exportar
            </Button>
          </FormFooter>
        </Col>
      </Row>
    </Form>
  );
};

BillingSearchForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  exportEndpoint: PropTypes.string,
};

BillingSearchForm.defaultProps = {
  exportEndpoint: '',
};

export default reduxForm({
  form: 'BillingSearchForm',
})(BillingSearchForm);
